<section class="card card-padding" aria-label="Import jobs">
  <!-- Header with collapse chevron + count -->
  <div class="flex items-start gap-2">
    <button
      type="button"
      (click)="toggleCollapsed()"
      class="rounded-lg p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary/40 transition-colors mt-0.5 flex-shrink-0"
      [attr.aria-expanded]="!collapsed()"
      [attr.aria-label]="collapsed() ? 'Expand import jobs' : 'Collapse import jobs'"
      data-testid="stream-toggle"
    >
      <svg
        class="w-5 h-5 transition-transform duration-200"
        [class.rotate-180]="!collapsed()"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
    <h2 class="section-title">
      Import jobs
      @if (currentJobs(); as p) {
        <span class="ml-1 text-base font-normal text-gray-500">({{ p.totalItems }})</span>
      }
    </h2>
  </div>

  @if (!collapsed()) {
    @if (showSkeleton()) {
      <div class="mt-3 flex flex-col gap-2 sm:gap-3" data-testid="job-stream-loading">
        @for (_ of [1, 2]; track $index) {
          <div class="animate-pulse rounded-lg border border-slate-200 bg-white p-3 sm:p-4">
            <div
              class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between md:gap-4"
            >
              <div class="flex flex-col gap-1 md:flex-row md:items-center md:gap-3 min-w-0">
                <div class="flex items-center gap-2">
                  <div class="h-7 w-7 rounded-full bg-slate-200 skeleton-shimmer"></div>
                  <div class="h-4 w-20 rounded bg-slate-200 skeleton-shimmer"></div>
                </div>
                <div class="hidden md:inline text-slate-300">·</div>
                <div class="flex flex-wrap items-center gap-2 min-w-0">
                  <div class="h-3 w-24 rounded bg-slate-200 skeleton-shimmer"></div>
                  <div class="h-3 w-16 rounded bg-slate-200 skeleton-shimmer"></div>
                  <div class="h-3 w-20 rounded bg-slate-200 skeleton-shimmer"></div>
                </div>
              </div>
              <div class="flex flex-shrink-0 items-center gap-1">
                <div class="h-6 w-20 rounded-full bg-slate-200 skeleton-shimmer"></div>
              </div>
            </div>
            <div class="mt-2 h-3 w-3/5 rounded bg-slate-200 skeleton-shimmer"></div>
          </div>
        }
      </div>
    } @else if (isEmpty()) {
      <div class="mt-3 rounded-lg border border-dashed border-slate-200 p-6 text-center">
        <p class="text-sm text-gray-600">
          No import jobs yet. Add papers to see import history here.
        </p>
      </div>
    } @else {
      <ul class="mt-3 flex flex-col gap-2 sm:gap-3">
        @for (job of orderedItems(); track job.id) {
          <li>
            <app-import-job-card
              [job]="job"
              [active]="isActive(job.id)"
              [canUndo]="canUndo"
              [currentUserId]="currentUserId"
              [piUserId]="piUserId"
              (cardClick)="onCardClick(job.id)"
              (detailClick)="onDetail(job.id)"
              (titleChange)="titleChange.emit($event)"
              (undoClick)="undoImport.emit($event)"
            ></app-import-job-card>
          </li>
        }
      </ul>
    }
  }
</section>
